import { faRobot } from "@fortawesome/free-solid-svg-icons/faRobot";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { Flex } from "../../../../../components/Flex";
import { Text } from "../../../../../components/Text";
import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { Rounded } from "../../../../../theme/Rounded";
import { Spacing } from "../../../../../theme/Spacing";

const Row = styled(Flex)`
  align-items: center;
  justify-content: center;
  gap: ${Spacing.s};
  margin: ${Spacing.s} 0;
`;

const Rule = styled.span`
  flex: 1;
  height: 1px;
  background-color: ${({ theme }) => theme.sub};
`;

const Note = styled(Flex)`
  align-items: center;
  gap: ${Spacing.xs};
  padding: ${Spacing.xs} ${Spacing.m};
  border-radius: ${Rounded.pill};
  background-color: ${({ theme }) => theme.lightSub};
  max-width: 70%;
`;

type Props = {
  message: ConversationMessage;
};

/** Something that happened to the conversation, rather than something someone
 * said. The customer never sees these.
 */
export const WASystemNote: React.FC<Props> = ({ message }) => {
  const { t } = useTranslation();

  const system = message.system;

  const agentName =
    system?.agentName || t("integration.whatsapp.meta.aiAgent.defaultName");

  const body = !system
    ? message.text?.body
    : system.kind === "takeover"
      ? t("integration.whatsapp.meta.handover.takeover", { name: agentName })
      : system.reason
        ? t("integration.whatsapp.meta.handover.note", {
            name: agentName,
            reason: system.reason,
          })
        : t("integration.whatsapp.meta.handover.noteNoReason", {
            name: agentName,
          });

  return (
    <Row>
      <Rule />

      <Note>
        <AtiraIcon icon={faRobot} size="xs" color="darkerSub" />
        <Text
          fontSize="xs"
          color="darkerSub"
          align="center"
          style={{ unicodeBidi: "plaintext" }}
        >
          {body}
        </Text>
      </Note>

      <Rule />
    </Row>
  );
};
